import { render, staticRenderFns } from "./HeaderNavigation.vue?vue&type=template&id=4babca54&scoped=true&"
import script from "./HeaderNavigation.vue?vue&type=script&lang=ts&"
export * from "./HeaderNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderNavigation.vue?vue&type=style&index=0&id=4babca54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4babca54",
  null
  
)

export default component.exports